import React, { useState } from 'react'
import { t } from '@lingui/macro'

import { CopyResourceModal } from '../copy-resource-modal/CopyResourceModal'
import IconDuplicate from 'front-end/src/components/common/icon/IconDuplicate'
import { brandColors } from 'shared/basicPalette'
import { ResourceItemActionButton } from './ResourceItemActionButton'

export const DuplicateResourceButton: React.FC<{
  topicId: number
  refetchTopics: () => Promise<any>
}> = (props) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <ResourceItemActionButton
        dataTest="CopyButton"
        className="ResourceListItem__actions-copy"
        hint={t`Create a copy`}
        aria-label={t`Create a copy`}
        onClick={() => {
          setShowModal(true)
        }}
        icon={<IconDuplicate color={brandColors.grey[500]} boxSize="16px" />}
      />
      {showModal && (
        <CopyResourceModal
          show
          topicId={props.topicId}
          onHide={() => {
            setShowModal(false)
            props.refetchTopics()
          }}
          onHidden={() => {
            setShowModal(false)
          }}
        />
      )}
    </>
  )
}
